import z from 'zod/v4';
import { CountryCode } from '../../index.js';
import { UserType } from '../index.js';
import { DataScope, FetchLevel, ProviderName, } from './index.js';
const DebbieProviderMetadata = {
    // Updates Cosmo with data from Debbie
    name: ProviderName.DEBBIE,
    supportedUserTypes: Object.values(UserType),
    supportedCountries: Object.values(CountryCode),
    isIdentityProvider: false,
    fetchLevel: FetchLevel.PER_USER,
    dataScope: DataScope.USER,
    alwaysEnabled: true,
};
const LEGACYProviderMetadata = {
    // Migration provider from legacy cosmo -> cosmov2
    name: ProviderName.LEGACY,
    supportedUserTypes: Object.values(UserType),
    supportedCountries: Object.values(CountryCode),
    isIdentityProvider: false,
    fetchLevel: FetchLevel.PER_USER,
    dataScope: DataScope.USER,
};
export const AKSProviderMetadata = {
    name: ProviderName.AKS,
    supportedUserTypes: [UserType.COMPANY, UserType.PERSON],
    supportedCountries: [CountryCode.DK],
    isIdentityProvider: true,
    fetchLevel: FetchLevel.PER_TENANT,
    dataScope: DataScope.STAR,
    settingsSchema: z.object({
        credentials: z
            .object({
            Aksnoegle: z.string().min(1).meta({ title: 'AKS nøgle' }),
            Akskode: z.string().min(1).meta({ title: 'AKS kode' }),
            Brugernavn: z.string().min(1).meta({ title: 'Brugernavn' }),
            Password: z.string().min(1).meta({ title: 'Password' }),
        })
            .meta({ title: 'Loginoplysninger' }),
    }),
};
const CVRProviderMetadata = {
    name: ProviderName.CVR,
    supportedUserTypes: [UserType.COMPANY],
    supportedCountries: [CountryCode.DK, CountryCode.GL],
    isIdentityProvider: true,
    fetchLevel: FetchLevel.PER_USER,
    dataScope: DataScope.STAR,
};
const CPRProviderMetadata = {
    name: ProviderName.CPR,
    supportedUserTypes: [UserType.PERSON],
    supportedCountries: [CountryCode.DK, CountryCode.GL],
    isIdentityProvider: true,
    fetchLevel: FetchLevel.PER_USER,
    dataScope: DataScope.STAR,
};
const TINGBOGENProviderMetadata = {
    name: ProviderName.TINGBOGEN,
    supportedUserTypes: [UserType.COMPANY, UserType.PERSON],
    supportedCountries: [CountryCode.DK, CountryCode.GL],
    isIdentityProvider: false,
    fetchLevel: FetchLevel.PER_USER,
    dataScope: DataScope.STAR,
};
const MAILVALIDATORProviderMetadata = {
    name: ProviderName.MAILVALIDATOR,
    supportedUserTypes: Object.values(UserType),
    supportedCountries: Object.values(CountryCode),
    isIdentityProvider: false,
    fetchLevel: FetchLevel.PER_USER,
    dataScope: DataScope.STAR,
};
const COURTProviderMetadata = {
    name: ProviderName.COURT,
    supportedUserTypes: [UserType.COMPANY, UserType.PERSON],
    supportedCountries: [CountryCode.DK, CountryCode.GL],
    isIdentityProvider: false,
    fetchLevel: FetchLevel.PER_USER,
    dataScope: DataScope.USER,
};
const VONAGEProviderMetadata = {
    name: ProviderName.VONAGE,
    supportedUserTypes: Object.values(UserType),
    supportedCountries: Object.values(CountryCode),
    isIdentityProvider: false,
    fetchLevel: FetchLevel.PER_USER,
    dataScope: DataScope.USER,
};
const EJFProviderMetadata = {
    // Ejerfortegnelsen - Danish property ownership registry
    name: ProviderName.EJF,
    supportedUserTypes: [UserType.COMPANY, UserType.PERSON],
    supportedCountries: [CountryCode.DK, CountryCode.GL],
    isIdentityProvider: false,
    fetchLevel: FetchLevel.PER_USER,
    dataScope: DataScope.STAR,
};
const MIGRATIONProviderMetadata = {
    // Stores historical data (e.g. previous addresses, emails and phone
    // numbers) migrated from other systems during imports
    name: ProviderName.MIGRATION,
    supportedUserTypes: Object.values(UserType),
    supportedCountries: Object.values(CountryCode),
    isIdentityProvider: false,
    fetchLevel: FetchLevel.PER_USER,
    dataScope: DataScope.USER,
};
const providerMetadata = {
    [ProviderName.AKS]: AKSProviderMetadata,
    [ProviderName.CVR]: CVRProviderMetadata,
    [ProviderName.CPR]: CPRProviderMetadata,
    [ProviderName.TINGBOGEN]: TINGBOGENProviderMetadata,
    [ProviderName.DEBBIE]: DebbieProviderMetadata,
    [ProviderName.MAILVALIDATOR]: MAILVALIDATORProviderMetadata,
    [ProviderName.COURT]: COURTProviderMetadata,
    [ProviderName.VONAGE]: VONAGEProviderMetadata,
    [ProviderName.LEGACY]: LEGACYProviderMetadata,
    [ProviderName.MIGRATION]: MIGRATIONProviderMetadata,
    [ProviderName.EJF]: EJFProviderMetadata,
};
const all = Object.values(providerMetadata);
export default {
    ...providerMetadata,
    all,
};
//# sourceMappingURL=metadata.js.map